import React, { FC } from "react";
import styled from "styled-components";
import { Subtotal } from "./Subtotal";
import { ItemDetailsProps } from "../common/types";
import { Button } from "@pepdirect/ui/button";
import { TimedWarning } from "../../alert/TimedWarning";

const StyledItemDetails = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  height: 31px;
  position: relative;
`;

const RemoveItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 15px;

  button {
    font-size: 12px;
    font-weight: 500;
    color: #666;
    text-decoration: underline;
  }
`;

const Error = styled.div`
  position: absolute;
  bottom: -10px;
`;

export const ItemDetails: FC<ItemDetailsProps> = ({
  productId,
  subtotal,
  quantity,
  error,
  children,
  updateCartItem,
  allowRemove = true,
}) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!productId) return;
    updateCartItem({
      productId,
      quantity: 0,
      subscriptionIntervalInDays: null,
    });
  };

  return (
    <StyledItemDetails>
      {children}

      {allowRemove && (
        <RemoveItem>
          <Button
            style={{ background: "black", color: "white" }}
            type="text"
            onClick={handleRemove}
          >
            Remove
          </Button>
        </RemoveItem>
      )}

      <Subtotal price={subtotal} quantity={quantity} showNotLaptop />

      <Error>
        <TimedWarning error={error} delay="4000" />
      </Error>
    </StyledItemDetails>
  );
};
